export enum BookingStatus {
    Pending = 0,
    Accepted = 1,
    Complete = 2,
    Cancelled = 3,
    Rejected = 4,
}
